import React, { useContext } from 'react';
import { Context as AISearchContext } from './context';
import {
  MenuBar,
  MenuButton,
  MenuTitle,
  MenuCount
} from './styles';

interface Props {
  historyOpen: boolean;
  onToggleHistory: () => void;
  onNewChat: () => void;
  /** Number of chats listed in History (chats with at least one prompt). */
  historyCount: number;
}

export const ChatMenu: React.FC<Props> = ({ historyOpen, onToggleHistory, onNewChat, historyCount }) => {
  const { activeChat } = useContext(AISearchContext);
  const title = historyOpen ? 'History' : activeChat?.title || 'New Chat';

  return (
    <MenuBar>
      <MenuButton
        type="button"
        onClick={onToggleHistory}
        aria-expanded={historyOpen}
        aria-controls={historyOpen ? 'ai-chat-history' : undefined}
      >
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M3 12a9 9 0 1 0 3-6.7M3 4v5h5M12 7v5l3 2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        {historyOpen ? 'Back to chat' : 'History'}
        {!historyOpen && historyCount > 0 && <MenuCount>{historyCount}</MenuCount>}
      </MenuButton>
      <MenuTitle title={activeChat?.title}>{title}</MenuTitle>
      <MenuButton type="button" onClick={onNewChat}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        New chat
      </MenuButton>
    </MenuBar>
  );
};
